var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "polygon-matic-logo 3",
    clipPath: "url(#clip0_721_85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.6771 8.82985C25.0573 8.48358 24.2604 8.48358 23.5521 8.82985L18.5938 11.6866L15.2292 13.5045L10.3594 16.3612C9.73958 16.7075 8.94271 16.7075 8.23438 16.3612L4.42708 14.1104C3.80729 13.7642 3.36458 13.0716 3.36458 12.2925V7.96418C3.36458 7.27164 3.71875 6.5791 4.42708 6.14627L8.23438 3.98209C8.85417 3.63582 9.65104 3.63582 10.3594 3.98209L14.1667 6.23284C14.7865 6.5791 15.2292 7.27164 15.2292 8.05075V10.9075L18.5938 9.00299V6.0597C18.5938 5.36716 18.2396 4.67463 17.5312 4.24179L10.4479 0.173135C9.82812 -0.173134 9.03125 -0.173134 8.32292 0.173135L1.0625 4.32836C0.354167 4.67463 0 5.36716 0 6.0597V14.197C0 14.8896 0.354167 15.5821 1.0625 16.0149L8.23438 20.0836C8.85417 20.4299 9.65104 20.4299 10.3594 20.0836L15.2292 17.3134L18.5938 15.409L23.4635 12.6388C24.0833 12.2925 24.8802 12.2925 25.5885 12.6388L29.3958 14.803C30.0156 15.1493 30.4583 15.8418 30.4583 16.6209V20.9493C30.4583 21.6418 30.1042 22.3343 29.3958 22.7672L25.6771 24.9313C25.0573 25.2776 24.2604 25.2776 23.5521 24.9313L19.7448 22.7672C19.125 22.4209 18.6823 21.7284 18.6823 20.9493V18.1791L15.3177 20.0836V22.9403C15.3177 23.6328 15.6719 24.3254 16.3802 24.7582L23.5521 28.8269C24.1719 29.1731 24.9687 29.1731 25.6771 28.8269L32.849 24.7582C33.4687 24.4119 33.9115 23.7194 33.9115 22.9403V14.7164C33.9115 14.0239 33.5573 13.3313 32.849 12.8985L25.6771 8.82985Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.d455cfafe167fafd484e55fadbc4e3c7.svg";
export { ForwardRef as ReactComponent };